import {ReactNode} from 'react';
import SwipeablePanel from '../../../components/drawer/drawer';
import {Grid} from '@mui/material';
import {useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import {AppBarProvider} from '../../../components/appBar/appBarContext';
import AssignedLoanCard from '../../../components/card/DrawerCards/AssignedLoanCard';
import {LOAN_CARD_INFO} from '../../../config/cacheKey';
import {IGetLoansInfoResponse} from '../../../models/registration.model';
import {getpervStateTab} from '../../../redux/loansTab/loansTabSlice';
import CustomisedTitleFont14 from '../../../components/title/titleFont14';
import {ChevronLeft} from '@mui/icons-material';

export default function DrawerBody({
    children,
    isAssigned,
}: {
    children: ReactNode;
    isAssigned?: boolean;
}) {
    return (
        <div className="px-[20px]">
            {isAssigned ? <AssignedLoanCard /> : <CardInfo />}

            <AppBarProvider>
                <SwipeablePanel isAssigned={isAssigned!}>
                    {children}
                </SwipeablePanel>
            </AppBarProvider>
        </div>
    );
}
export const CardInfo = () => {
    const queryClient = useQueryClient();
    const lonaInfo: IGetLoansInfoResponse | undefined =
        queryClient.getQueryData(LOAN_CARD_INFO);
    const dispatch = useDispatch();
    return (
        <div className="my-2 bg-[var(--input-bg-color)] overflow-hidden h-[calc(33svh-115px)] short:h-[unset] p-4 border-[1px] border-[rgba(0,0,0,0.12)] rounded-[8px]">
            <div className="w-full h-full flex flex-col justify-between">
                <div className="flex items-center justify-end text-[#BBA57A] cursor-pointer">
                    <span
                        className="text-[.785rem]"
                        onClick={() => {
                            dispatch(
                                getpervStateTab({
                                    prevState: 'loanDetail',
                                })
                            );
                        }}
                    >
                        مشاهده جزییات
                    </span>
                    <ChevronLeft />
                </div>
                <div
                    className="flex flex-col items-center text-[var(--primary-text-color)]"
                    style={{fontSize: '18px'}}
                >
                    <div className="font-bold" style={{fontSize: '1.2rem'}}>
                        {lonaInfo?.loanAmount?.toLocaleString('fa')}
                        <span className="font-normal"> ریال</span>
                    </div>
                    <div style={{fontSize: '1rem'}}>
                        {lonaInfo?.financialSupplierTitle}
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <div className="text-[#BBA57A] text-[.785rem]">
                        مبلغ هر قسط (ريال):
                    </div>
                    <div
                        className=" !mt-2 "
                        style={{
                            fontSize: '.785rem',
                            letterSpacing: '1.5px',
                        }}
                    >
                        {lonaInfo?.installmentAmount.toLocaleString('fa')}
                    </div>
                </div>
            </div>
        </div>
    );
};
